import type { JSX } from 'react';

type SpeedIconProps = {
  className?: string;
  variant: 'default' | 'white';
};

const SpeedIcon = (props: SpeedIconProps): JSX.Element => {
  const { className, variant } = props;
  switch (variant) {
    case 'white':
      return (
        <svg
          className={className || ''}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
        >
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M2.318 12.708h.528a.625.625 0 0 1 0 1.25H1.668a.625.625 0 0 1-.625-.625 8.958 8.958 0 0 1 17.917 0 .625.625 0 0 1-.661.624.606.606 0 0 1-.036.001h-1.178a.625.625 0 0 1 0-1.25h.6a7.675 7.675 0 0 0-1.809-4.366l-.433.433a.625.625 0 1 1-.884-.884l.433-.432a7.675 7.675 0 0 0-4.366-1.809v.529a.625.625 0 1 1-1.25 0V5.65A7.675 7.675 0 0 0 5.01 7.459l.433.432a.625.625 0 0 1-.884.884l-.432-.433a7.675 7.675 0 0 0-1.81 4.366Zm11.459-3.15a.625.625 0 0 1 0 .884l-3.334 3.333a.625.625 0 1 1-.884-.884l3.334-3.333a.625.625 0 0 1 .884 0Z"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'default':
    default:
      return (
        <svg
          className={className || ''}
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="none"
        >
          <path
            fill="#121212"
            fillRule="evenodd"
            d="M2.318 12.708h.528a.625.625 0 0 1 0 1.25H1.668a.625.625 0 0 1-.625-.625 8.958 8.958 0 0 1 17.917 0 .625.625 0 0 1-.661.624.606.606 0 0 1-.036.001h-1.178a.625.625 0 0 1 0-1.25h.6a7.675 7.675 0 0 0-1.809-4.366l-.433.433a.625.625 0 1 1-.884-.884l.433-.432a7.675 7.675 0 0 0-4.366-1.809v.529a.625.625 0 1 1-1.25 0V5.65A7.675 7.675 0 0 0 5.01 7.459l.433.432a.625.625 0 0 1-.884.884l-.432-.433a7.675 7.675 0 0 0-1.81 4.366Zm11.459-3.15a.625.625 0 0 1 0 .884l-3.334 3.333a.625.625 0 1 1-.884-.884l3.334-3.333a.625.625 0 0 1 .884 0Z"
            clipRule="evenodd"
          />
        </svg>
      );
  }
};
export default SpeedIcon;
